import React from "react";
import LeftImg from './images/services/customer-img.jpg'
import Icon01 from './images/services/customer-1.png'
import Icon02 from './images/services/customer-2.png'
import Icon03 from './images/services/customer-3.png'
import Icon04 from './images/services/customer-4.png'
import Icon05 from './images/services/customer-5.png'
function CustomerInfo() {
  return (
    <section className="image-description-section section">
        <p className="section-heading">Provide high-quality, 24 x 7 customer support to your clients, organization and community!</p>
    <div className="image-description-left image-section-left">
        <img src={LeftImg} alt="Description Image" className="image_description"
        style={{filter:'invert(0)'}}
        />
    </div>
    <div className="image-description-right description">
        <h2 className="heading-underline">Key Features</h2>
        <p className="description-para">
            <img src={Icon01} width={30} height={30} className="img-fluid" alt="icons"/>
            Automate Customer support using AI that understands your business.</p>
        <p className="description-para">
            <img src={Icon02} width={30} height={30} className="img-fluid" alt="icons"/>
            Create and train your AI Agent on your own unique knowledge base. </p>
        <p className="description-para">
            <img src={Icon03} width={30} height={30} className="img-fluid" alt="icons"/>
            24 x 7 x 365 always on service </p>
        <p className="description-para">
            <img src={Icon04} width={30} height={30} className="img-fluid" alt="icons"/>
            Text & Voice chat available with interactive multimedia responses</p>
        <p className="description-para">
            <img src={Icon05} width={30} height={30} className="img-fluid" alt="icons"/>
            Simple to set up and deploy</p>
    </div>
</section>  
  )
}
export default CustomerInfo;